import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActivePackagingProps extends ModalEditComponentProps { }

const ModalChangeActivePackaging: React.FC<ModalChangeActivePackagingProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivatePackaging {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeletePackaging {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivatePackagingProps extends ModalEditComponentProps { }

const ModalReactivatePackaging: React.FC<ModalReactivatePackagingProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/updateProduct',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisPackaging', '¿Seguro que quieres reactivar este packaging?'),
            subtitle: t('onceReactivatedAbleInList', 'Una vez reactivado volverá a aparecer en el listado'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeletePackagingProps extends ModalEditComponentProps { }

const ModalDeletePackaging: React.FC<ModalDeletePackagingProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/deleteProduct',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnablePackaging', '¿Seguro que quieres desactivar este packaging?'),
            subtitle: t('onceUnabledCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('unable', 'Desactivar')
        }} />
    )
}

export default ModalChangeActivePackaging